import React from 'react';
import { Paper, ListSubheader } from '@mui/material';
import { useLoadGraphDetails } from '../../data/DataProviders/LoadGraphDataProvider';
import { isDataLoaded } from '../../types/data-providers';
import { DataIndicators } from '../DataIndicators';
import { LoadGraphParameter } from '../../constants/lineGraphParameter';
import { LineGraph } from '../LineGraph/LineGraph';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
import { Icon } from '../../lib/icons';
export const LoadGraph: React.FC = () => {
    const responseLoadGraphData = useLoadGraphDetails();
    const classes = chartLabelNameStyle();
    const isEmpty = isDataLoaded(responseLoadGraphData) ? responseLoadGraphData.value.chartData.length === 0 : false;
    const tickInterval = 336 * 3600 * 1000;
    const maxValueData: object[] = [];
    let startDate: any;
    let endDate: any;
    if (isDataLoaded(responseLoadGraphData)) {
        startDate = (isDataLoaded(responseLoadGraphData) && responseLoadGraphData.value.startDate) || '';
        endDate = (isDataLoaded(responseLoadGraphData) && responseLoadGraphData.value.endDate) || '';
        responseLoadGraphData.value.chartData.filter((data: any) => {
            if (new Date(data.dateTime) >= new Date(startDate) || new Date(data.dateTime) <= new Date(endDate)) {
                const highLoadData: any = parseFloat(data.highLoad);
                const fulldate = new Date(data.dateTime).getTime();
                maxValueData.push([fulldate, highLoadData]);
            }
            return true;
        });
    }
    let chartLabelName;
    LoadGraphParameter.map((temp: any) => {
        chartLabelName = temp.chartLabelName;
    });
    return (
        <div data-testid="device-info-loadGraph" id="loadGraph" style={{ border: '1px solid #dfe1e1', borderRadius: '5px' }}>
            <Paper elevation={0} variant="outlined" style={{ border: '0px' }}>
                <DataIndicators
                    errorMessage="Record not found"
                    emptyMessage="Record not found"
                    data={responseLoadGraphData}
                    emptyIcon="BarChart"
                    isEmpty={isEmpty}
                    isDetailedInfo={false}
                />
            </Paper>

            {isDataLoaded(responseLoadGraphData) && (
                <>
                    {responseLoadGraphData.value.chartData.length > 0 && (
                        <Paper elevation={0} variant="outlined">
                            <Paper elevation={0} variant="outlined">
                            <div className={classes.titleBoxContent}>
                                <ListSubheader color="primary" component="div" style={{ fontWeight: 600 }}>
                                   {chartLabelName}
                                    <span className={classes.icon}>
                                        {<Icon.Info className={classes.infoicon}/>}
                                    </span>
                                </ListSubheader>                               
                            </div>     
                                <LineGraph
                                    startDate={startDate}
                                    endDate={endDate}
                                    maxValueData={maxValueData}
                                    highChartGraphParameter = {LoadGraphParameter}
                                    tickInterval = {tickInterval} 
                                />
                            </Paper>
                        </Paper>
                    )}
                </>
            )}
        </div>
    );
};
